import { useCallback, useState } from 'react'

import { AccessibleText } from '@/legacy/components/AccessibleText'
import { ScreenReaderNotifier } from '@/legacy/components/ScreenReaderNotifier'
import { BodyM } from '@/legacy/components/Typography'

import { useSelectIconEvent } from '@/legacy/core/analytics/hooks'

import { useBlogArticleCms } from '@/legacy/providers/BlogArticleCmsProvider'

import ErrorMessage from '../ErrorMessage'

import StarInput from '../StarInput'

import { FormStyles } from './styles'

const STARS = [
  { id: 1, label: '1 Estrela (Discordo totalmente)' },
  { id: 2, label: '2 Estrelas (Discordo)' },
  { id: 3, label: '3 Estrelas (Neutro)' },
  { id: 4, label: '4 Estrelas (Concordo)' },
  { id: 5, label: '5 Estrelas (Concordo Totalmente)' },
]

export type FormProps = {
  rating: number
  onChangeRating: (event: React.ChangeEvent<HTMLInputElement>) => void
  showError: boolean
  showSuccess: boolean
}

const Form = ({ rating, showError, showSuccess, onChangeRating }: FormProps) => {
  const { contentReview } = useBlogArticleCms()
  const selectIconEvent = useSelectIconEvent({ itemId: 'serasa-web_web_icone_meio_10' })
  const [itemHover, setItemHover] = useState(0)

  const trackRatingEvent = useCallback(
    (ratingValue: number) => {
      if (showSuccess) {
        return selectIconEvent({
          label: `nota-atualizada-${ratingValue}-nota-anterior-${rating}`,
        })
      }
      selectIconEvent({ label: `nota-${ratingValue}` })
    },
    [selectIconEvent, showSuccess, rating],
  )

  const averageArticleRating =
    contentReview?.averageRating && parseFloat(contentReview.averageRating.toFixed(2))

  return (
    <FormStyles name="content-review">
      <fieldset aria-label="Avaliação do conteúdo">
        <BodyM tag="legend" color="dark-medium" className="rating-label">
          Escolha de 1 a 5 estrelas para avaliar
        </BodyM>

        <div className="star-rating-container">
          <div className="stars" onMouseLeave={() => setItemHover(0)}>
            {STARS.map((item, index) => (
              <StarInput
                itemOnHover={itemHover}
                checked={rating >= item.id}
                key={index}
                item={item}
                onChange={onChangeRating}
                onMouseOver={() => setItemHover(item.id)}
                onClick={() => trackRatingEvent(item.id)}
              />
            ))}
          </div>
        </div>
        <AccessibleText
          text={`Média: ${averageArticleRating} / 5`}
          accessibleText={`Média de avaliação: ${averageArticleRating} de 5`}
          shouldDisplay={!!averageArticleRating}
          color="dark-medium"
        />
      </fieldset>

      <ScreenReaderNotifier
        label="Erro ao avaliar o artigo! Tente novamente"
        enabled={showError}
        allowSuppressOtherElements={false}
      >
        <ErrorMessage />
      </ScreenReaderNotifier>

      <ScreenReaderNotifier
        label="Obrigado pela avaliação!"
        enabled={showSuccess}
        allowSuppressOtherElements={false}
      >
        <BodyM aria-hidden emphasys color="dark-medium">
          Obrigado pela avaliação!
        </BodyM>
      </ScreenReaderNotifier>
    </FormStyles>
  )
}
export default Form
